import React from "react";
import { UserExamAnswerApi, UserExamApi } from "api/userExamsApi";

type ActionType =
  | { type: "INITIALIZE_EXAM"; payload: UserExamApi }
  | {
      type: "REVIEW_ANSWER";
      payload: ReviewAnswerPayload;
    };

export type ReviewAnswerPayload = {
  userExamAnswerId: number;
  comment?: string;
  passed: boolean | null;
  points: number | null;
};
type ReviewExamState = {
  exam: UserExamApi;
  answers: UserExamAnswerApi[];
};

function reviewExamReducer(state: ReviewExamState, action: ActionType): ReviewExamState {
  switch (action.type) {
    case "INITIALIZE_EXAM":
      return { ...state, exam: action.payload, answers: action.payload.answers };
    case "REVIEW_ANSWER":
      return {
        ...state,
        answers: state.answers.map((answer) => {
          if (answer.userExamAnswerId === action.payload.userExamAnswerId) {
            return {
              ...answer,
              review: {
                comment: action.payload.comment,
                passed: action.payload.passed,
                points: action.payload.points,
              },
            };
          }
          return answer;
        }),
      };
    default:
      return state;
  }
}

interface ReviewExamContextType {
  state: ReviewExamState;
  dispatch: React.Dispatch<ActionType>;
}

const ReviewExamContext = React.createContext<ReviewExamContextType | undefined>(undefined);

export const ReviewExamProvider = ({ children }: React.PropsWithChildren) => {
  const [state, dispatch] = React.useReducer(reviewExamReducer, {
    exam: {} as UserExamApi,
    answers: [],
  });

  const value = { state, dispatch };

  return <ReviewExamContext.Provider value={value}>{children}</ReviewExamContext.Provider>;
};
export function useReviewExam() {
  const context = React.useContext(ReviewExamContext);
  if (context === undefined) {
    throw new Error("useReviewExam must be used within a ReviewExamContext");
  }
  return context;
}
